var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "table-container" },
    [
      _c(
        "SearchPanel",
        { attrs: { flex: "", size: "mini" } },
        [
          _c(
            "div",
            [
              _c("p", [_vm._v("开票单据号：")]),
              _c("el-input", {
                attrs: { size: "mini", placeholder: "请输入", clearable: "" },
                model: {
                  value: _setup.state.searchParams.billingInvoiceNo,
                  callback: function ($$v) {
                    _vm.$set(_setup.state.searchParams, "billingInvoiceNo", $$v)
                  },
                  expression: "state.searchParams.billingInvoiceNo",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v("发票类型：")]),
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "请选择",
                    size: "mini",
                    filterable: "",
                    clearable: "",
                  },
                  model: {
                    value: _setup.state.searchParams.invoiceType,
                    callback: function ($$v) {
                      _vm.$set(_setup.state.searchParams, "invoiceType", $$v)
                    },
                    expression: "state.searchParams.invoiceType",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "电子发票", value: 1 } }),
                  _c("el-option", { attrs: { label: "纸质发票", value: 2 } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v("发票种类：")]),
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "请选择",
                    size: "mini",
                    filterable: "",
                    clearable: "",
                  },
                  model: {
                    value: _setup.state.searchParams.invoiceSpecies,
                    callback: function ($$v) {
                      _vm.$set(_setup.state.searchParams, "invoiceSpecies", $$v)
                    },
                    expression: "state.searchParams.invoiceSpecies",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "专票", value: 1 } }),
                  _c("el-option", { attrs: { label: "普票", value: 2 } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v("供应商：")]),
              _c("el-input", {
                attrs: { size: "mini", placeholder: "请输入", clearable: "" },
                model: {
                  value: _setup.state.searchParams.supplierName,
                  callback: function ($$v) {
                    _vm.$set(_setup.state.searchParams, "supplierName", $$v)
                  },
                  expression: "state.searchParams.supplierName",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v("创建时间：")]),
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "value-format": "timestamp",
                  size: "mini",
                },
                model: {
                  value: _setup.datePickerTime,
                  callback: function ($$v) {
                    _setup.datePickerTime = $$v
                  },
                  expression: "datePickerTime",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v("销售渠道：")]),
              _c(
                "el-select",
                {
                  attrs: {
                    size: "mini",
                    placeholder: "请选择状态",
                    filterable: "",
                    clearable: "",
                  },
                  on: {
                    change: function ($event) {
                      return _setup.getInvoicedList()
                    },
                  },
                  model: {
                    value: _setup.state.searchParams.channelType,
                    callback: function ($$v) {
                      _vm.$set(_setup.state.searchParams, "channelType", $$v)
                    },
                    expression: "state.searchParams.channelType",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "本平台", value: "1" } }),
                  _c("el-option", { attrs: { label: "沪上公社", value: "2" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { slot: "button-right", size: "mini" },
              on: { click: _setup.getInvoicedList },
              slot: "button-right",
            },
            [_vm._v(" 查 询 ")]
          ),
          _c(
            "el-button",
            {
              attrs: { slot: "button-right", size: "mini" },
              on: { click: _setup.resetInvoicedList },
              slot: "button-right",
            },
            [_vm._v(" 重 置 ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _setup.state.loading,
              expression: "state.loading",
            },
          ],
          attrs: {
            "element-loading-text": "拼命加载中",
            data: _setup.state.tableData,
            border: "",
            "header-row-style": { "font-weight": 100, color: "#0D0202" },
            "row-style": { "font-size": "14px", color: "#0D0202" },
            "header-cell-style": {
              "font-weight": "bold",
              background: "#F0F2F8",
            },
          },
          on: { "selection-change": _setup.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "100" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "billingInvoiceNo",
              label: "开票单据号",
              "min-width": "200px",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "channelTypeName", label: "销售渠道" },
          }),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "创建时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _setup
                            .dayjs(Number(row.createTime))
                            .format("YYYY-MM-DD HH:mm:ss")
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "invoiceAmount", label: "开票金额（元）" },
          }),
          _c("el-table-column", {
            attrs: { prop: "auditStatus", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [
                      _vm._v(_vm._s(_setup.getStatus(row.auditStatus))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "invoiceType", label: "发票类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(" " + _vm._s(_setup.getInvoicedTypeText(row)) + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "invoiceSpecies", label: "发票种类" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " + _vm._s(_setup.getInvoiceSpeciesText(row)) + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "supplierName", label: "供应商" },
          }),
          _c("el-table-column", {
            attrs: { prop: "payment", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _setup.openInvoicing(row, "info", "view")
                          },
                        },
                      },
                      [_vm._v(" 查看 ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _setup.state.tableData && _setup.state.tableData.length > 0
        ? _c("el-pagination", {
            attrs: {
              "current-page": _setup.state.page.currentPage,
              "page-sizes": [10, 20, 30, 50],
              "page-size": _setup.state.page.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _setup.state.page.total,
            },
            on: {
              "size-change": _setup.handleSizeChange,
              "current-change": _setup.handleCurrentChange,
            },
          })
        : _vm._e(),
      _c(_setup.invoicingInfoModal, {
        attrs: {
          visible: _setup.state.invoicingDialog.infoVisible,
          selected: _setup.state.selected,
          mode: _setup.state.invoicingDialog.mode,
        },
        on: {
          "update:visible": function ($event) {
            return _vm.$set(_setup.state.invoicingDialog, "infoVisible", $event)
          },
          toSubmit: _setup.toSubmit,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }